// import qs from 'qs'
import axios from 'axios'

export const fileUploadService = ({
  listAllFiles (token) {
    return axios.get('/api/FileRepository/ListAll', {headers: {'Authorization': 'Bearer ' + token}})
  },
  getSingleFile (token, fileId) {
    return axios.get('/api/filerepository/single?fileId=' + fileId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createFile (token, formDataObj) {
    return axios.post('/api/FileRepository/Create', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateFile (token, formDataObj) {
    return axios.put('/api/FileRepository/Update', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteFile (token, fileId) {
    return axios.delete('/api/FileRepository/Delete?fileId=' + fileId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/file-upload-service.js